import { randomNumber } from '../../../../utilities'
import { CardiacConstants } from './cardiac.constants'
import { ICardiacActions, ICardiacState } from './cardiac.types'

export const initialCardiacState: ICardiacState = {
  joulesHiddenFlag: true,
  leadChangeHiddenFlag: true,
  defibTypeHiddenFlag: true,
  typeHiddenFlag: true,
  action: null,
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  joules: '',
  leadChange: [],
  defibType: null,
  waveformType: null,
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Cardiac',
  saveResponse: '',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  mAHiddenFlag: true,
  heartRateHiddenFlag: true,
  pacingModeHiddenFlag: true,
  compressionRateHiddenFlag: true,
  locationHiddenFlag: true,
  mA: '',
  heartRate: '',
  pacingMode: null,
  compressionRate: null,
  location: null,
  mechanicalCprTypeHiddenFlag: true,
  mechanicalCprType: null,
  isEkgImport: null,
  cardiacDefaults: null,
  nemsisCode: null,
}

export function cardiacReducer(state: ICardiacState = initialCardiacState, action: ICardiacActions): ICardiacState {
  switch (action.type) {
    case CardiacConstants.SET_ACTION:
      return { ...state, action: action.action }
    case CardiacConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case CardiacConstants.SET_DATE:
      return { ...state, date: action.date }
    case CardiacConstants.SET_TIME:
      return { ...state, time: action.time }
    case CardiacConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case CardiacConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case CardiacConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case CardiacConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case CardiacConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case CardiacConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case CardiacConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case CardiacConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case CardiacConstants.SET_LEAD_CHANGE:
      return { ...state, leadChange: action.leadChange }
    case CardiacConstants.SET_JOULES:
      return { ...state, joules: action.joules }
    case CardiacConstants.SET_DEFIB_TYPE:
      return { ...state, defibType: action.defibType }
    case CardiacConstants.SET_TYPE:
      return { ...state, waveformType: action.waveformType }
    case CardiacConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case CardiacConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case CardiacConstants.SET_STATE:
      return { ...action.cardiacState, updateInputRows: true }
    case CardiacConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case CardiacConstants.SET_SAVE_RESPONSE:
      return { ...state, saveResponse: action.saveResponse }
    case CardiacConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case CardiacConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case CardiacConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case CardiacConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case CardiacConstants.SET_MA:
      return { ...state, mA: action.mA }
    case CardiacConstants.SET_HEART_RATE:
      return { ...state, heartRate: action.heartRate }
    case CardiacConstants.SET_PACING_MODE:
      return { ...state, pacingMode: action.pacingMode }
    case CardiacConstants.SET_COMPRESSION_RATE:
      return { ...state, compressionRate: action.compressionRate }
    case CardiacConstants.SET_LOCATION:
      return { ...state, location: action.location }
    case CardiacConstants.SET_MECHANICAL_CPR_TYPE:
      return { ...state, mechanicalCprType: action.mechanicalCprType }
    case CardiacConstants.SET_CARDIAC_DEFAULTS:
      return { ...state, cardiacDefaults: action.cardiacDefaults }
    case CardiacConstants.RESET_TO_INITIAL_STATE:
      return {
        ...state,
        defibType: null,
        joules: '',
        waveformType: null,
        heartRate: '',
        mA: '',
        pacingMode: null,
        leadChange: [],
        location: null,
        compressionRate: null,
        mechanicalCprType: null,
      }
    case CardiacConstants.RESET_STATE:
      return {
        key: randomNumber().toString(),
        date: '',
        time: '',
        assessedBy: null,
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        joulesHiddenFlag: true,
        leadChangeHiddenFlag: true,
        defibTypeHiddenFlag: true,
        typeHiddenFlag: true,
        action: null,
        joules: '',
        leadChange: [],
        defibType: null,
        waveformType: null,
        type: 'Cardiac',
        saveResponse: '',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        mAHiddenFlag: true,
        heartRateHiddenFlag: true,
        pacingModeHiddenFlag: true,
        compressionRateHiddenFlag: true,
        locationHiddenFlag: true,
        mA: '',
        heartRate: '',
        pacingMode: null,
        compressionRate: null,
        location: null,
        mechanicalCprTypeHiddenFlag: true,
        mechanicalCprType: null,
        isEkgImport: null,
        cardiacDefaults: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
